@if (theme) {
  <div
    class="resources__container {{ theme?.root }} bg-cover bg-no-repeat bg-center"
    [style]="theme?.bgImage"
    >
    <div class="container {{ theme.container }}">
      @if (resourceTitle) {
        <div
          class="py-v-spacing sm:px-v-spacing max-w-container mx-auto wysiwyg"
          [innerHTML]="resourceTitle"
        ></div>
      }
      <div class="flex justify-center items-stretch flex-col lg:flex-row sm:px-v-spacing">
        @if (resourceCards && resourceCards.length % 2 == 0) {
          @for (card of resourceCards; track card; let last = $last; let first = $first) {
            <resource-card
              [data]="card"
              [cardLocation]="getCardLocation(first, last)"
              class="card card-even flex items-start lg:mb-v-spacing lg:py-v-spacing lg:mb-0"
          [ngClass]="{
            'lg:mr-v-spacing pt-v-spacing': !last,
            'py-v-spacing': last,
          }"
              >
            </resource-card>
          }
        } @else {
          @for (card of resourceCards; track card; let last = $last; let first = $first) {
            <resource-card
              [data]="card"
              [cardLocation]="getCardLocation(first, last)"
              class="card flex items-start lg:py-v-spacing"
          [ngClass]="{
            'card-odd mb-v-spacing lg:mb-0': resourceCards && resourceCards.length > 1,
            'mb-v-spacing lg:mb-0': !resourceCards || resourceCards.length === 0,
            'lg:mr-v-spacing pt-v-spacing': !last,
            'py-v-spacing': last
          }"
              >
            </resource-card>
          }
        }
      </div>
    </div>
  </div>
}
